import * as types from '../types/authTypes';
import { READER_TOKEN_KEY } from '../types/authTypes';

const getInitialToken = () => {
  try {
    return localStorage.getItem(READER_TOKEN_KEY);
  } catch {
    return null;
  }
};

const initialState = {
  user: null,
  token: getInitialToken(),
  loginLoading: false,
  registerLoading: false,
  initializing: false,
  error: null,
  isAuthenticated: !!getInitialToken(),
};

export default function authReducer(state = initialState, action) {
  switch (action.type) {
    case types.LOGIN_REQUEST:
      return { ...state, loginLoading: true, error: null };
    case types.REGISTER_REQUEST:
      return { ...state, registerLoading: true, error: null };
    case types.GET_USER_REQUEST:
      return { ...state, initializing: true, error: null };
    case types.LOGIN_SUCCESS:
    case types.REGISTER_SUCCESS:
      return {
        ...state,
        loginLoading: false,
        registerLoading: false,
        initializing: false,
        token: action.payload.token,
        user: action.payload.user,
        isAuthenticated: true,
        error: null,
      };
    case types.GET_USER_SUCCESS:
      return {
        ...state,
        initializing: false,
        user: action.payload,
        isAuthenticated: true,
        error: null,
      };
    case types.LOGIN_FAILURE:
      return {
        ...state,
        loginLoading: false,
        error: action.payload,
        isAuthenticated: false,
        token: null,
        user: null,
      };
    case types.REGISTER_FAILURE:
      return {
        ...state,
        registerLoading: false,
        error: action.payload,
        isAuthenticated: false,
        token: null,
        user: null,
      };
    case types.GET_USER_FAILURE:
      return {
        ...state,
        initializing: false,
        error: action.payload,
        isAuthenticated: false,
        token: null,
        user: null,
      };
    case types.LOGOUT:
      return {
        ...state,
        user: null,
        token: null,
        isAuthenticated: false,
        error: null,
        loginLoading: false,
        registerLoading: false,
        initializing: false,
      };
    default:
      return state;
  }
}
